<template>
  <div class="private-doctor-page">
    <AppHeader title="私人医生一对一解答" :show-back="true" @back="onBack" />

    <div class="pd-body" :style="pdBodyStyle">
      <div class="pd-banner">
        <img
          src="@/assets/serviceImg/service/5d9b101dff0154d0575f9c6089a1f56c23cd1e5e7203-FPxWES_fw1200_1@2x.png"
          alt="私人医生"
          class="pd-banner-img"
        />
        <div class="pd-banner-text">
          <div class="pd-banner-title">私人医生一对一解答</div>
          <div class="pd-banner-desc">成为您的私人医生管家</div>
        </div>
      </div>

      <section class="pd-section">
        <div class="pd-section-title">服务介绍</div>
        <div class="pd-section-content">
          一对一配备境内三甲医院心血管专科执业医生，持证5年以上临床经验，提供健康管控、疾病防治、慢病养护服务，帮助控制病情，延缓并发症，提升生活质量。
        </div>
      </section>

      <section class="pd-section">
        <div class="pd-section-title">核心服务</div>
        <ul class="pd-service-list">
          <li v-for="item in coreServices" :key="item">{{ item }}</li>
        </ul>
      </section>

      <section class="pd-section">
        <div class="pd-section-title">所需资料</div>
        <div class="pd-section-content">
          提供身高、体重、病史、体检报告、用药资料等
        </div>
      </section>

      <section class="pd-section">
        <div class="pd-section-title">使用方式</div>
        <div class="pd-section-content">
          下载【大救星健康版】APP，实名注册自动匹配专属医生；线上全流程服务，有效期内不限咨询服务次数，绑定监测设备即可使用。
        </div>
      </section>

      <section class="pd-qr-section">
        <div class="pd-section-title pd-qr-title">加入私人医生专属群</div>
        <div class="pd-qr-wrap">
          <img :src="qrCodeUrl" alt="私人医生群二维码" class="pd-qr-code" />
        </div>
        <div class="pd-qr-tip">
          为了更快捷服务于您，可以通过微信扫码进入私人医生服务群，专业医师日常解答
        </div>
        <div class="pd-action-buttons">
          <van-button type="primary" class="pd-action-btn pd-save-btn" @click="saveQRCode">
            保存二维码
          </van-button>
          <van-button
            v-if="!($env && $env.inMiniProgram)"
            type="primary"
            class="pd-action-btn pd-share-btn"
            @click="shareToWeChat"
          >
            分享到微信
          </van-button>
        </div>
      </section>
    </div>

    <div v-if="showModal" class="pd-modal">
      <div class="pd-modal-content">
        <span class="pd-modal-close" @click="showModal = false">&times;</span>
        <p class="pd-modal-tip">该项权益需开通以下服务权益</p>
        <div class="pd-modal-card" @click="goEquity">
          <img class="pd-modal-card-bg" src="@/assets/img/qykbj.png" alt="" />
          <h3 class="pd-modal-card-title">大救星-星健康权益卡</h3>
          <div class="pd-modal-card-desc">多项健康权益尊享，为您健康守护</div>
          <div class="pd-modal-card-btn">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import { mapState } from 'pinia'
import { useGlobalStore } from '@/stores/global'

/** 私人医生专属群二维码 */
const PRIVATE_DOCTOR_QR_URL =
  'https://health.dajiuxing.com.cn/health/api/upload/3ac7e563-c415-4922-a266-aa450cd49f16.jpg'

export default {
  name: 'PrivateDoctor',
  components: {
    AppHeader
  },
  data() {
    return {
      showModal: false,
      equityinfoType: false,
      qrCodeUrl: PRIVATE_DOCTOR_QR_URL,
      coreServices: [
        '精准评估',
        '科学用药',
        '监测异常数据解读',
        '行为干预，涵盖饮食/运动/心理/康复全方面',
        '教育赋能：健康科普指导',
        '团队协作：医护康养多师团队服务',
        '长期跟踪：定期随访、长期健康跟踪'
      ]
    }
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    /**
     * 内容区顶距：AppHeader 高度（statusBar + 48px）+ 50px
     * @returns {{ paddingTop: string }}
     */
    pdBodyStyle() {
      const headerHeight = Number(this.statusBarHeight || 0) + 48
      return { paddingTop: headerHeight + 20 + 'px' }
    }
  },
  created() {
    document.title = '私人医生一对一解答'
    this.equityinfoType = localStorage.getItem('equityinfo')
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px'
    }
    document.querySelector('#app').setAttribute('style', 'background-color:#F2F3F5')
  },
  methods: {
    /**
     * 返回 newIndex（服务页入口），避免 history 异常时退到登录页
     * @returns {void}
     */
    onBack() {
      this.$router.push({ name: 'newIndex' }).catch(() => {})
    },
    /**
     * 跳转权益卡介绍
     */
    goEquity() {
      this.$router.push({ path: '/equity', query: {} }).catch(() => {})
    },
    /**
     * 校验权益后执行回调
     * @param {() => void} callback
     */
    checkRightsAndHandle(callback) {
      if (this.equityinfoType === false || this.equityinfoType === 'false') {
        this.showModal = true
        return
      }
      if (callback && typeof callback === 'function') {
        callback()
      }
    },
    /**
     * 保存私人医生群二维码
     */
    saveQRCode() {
      this.checkRightsAndHandle(() => {
        const qrCodeUrl = this.qrCodeUrl
        const inApp = this.$env && this.$env.inDjxApp
        const inMiniProgram = this.$env && this.$env.inMiniProgram

        if (inApp) {
          window.location.href = 'appdjxhealth://actionSavePicture?picUrl=' + qrCodeUrl
          return
        }

        if (
          inMiniProgram &&
          typeof wx !== 'undefined' &&
          wx.miniProgram &&
          typeof wx.miniProgram.navigateTo === 'function'
        ) {
          try {
            const u = encodeURIComponent(qrCodeUrl)
            wx.miniProgram.navigateTo({ url: `/pages/qrAction/index?action=save&url=${u}` })
          } catch (e) {
            console.warn('miniProgram navigateTo save qr failed', e)
          }
          return
        }

        window.location.href = 'appdjxhealth://actionSavePicture?picUrl=' + qrCodeUrl
      })
    },
    /**
     * 分享二维码到微信
     */
    shareToWeChat() {
      this.checkRightsAndHandle(() => {
        const inApp = this.$env && this.$env.inDjxApp
        const inMiniProgram = this.$env && this.$env.inMiniProgram

        if (inApp) {
          if (this.$env.inAndroid) {
            try {
              JSInterface.shareWeChatWorkQR()
            } catch (error) {
              console.log(error)
            }
          } else if (this.$env.inIos) {
            try {
              window.webkit.messageHandlers.shareWeChatWorkQR.postMessage(null)
            } catch (error) {
              console.log(error)
            }
          }
          return
        }

        if (
          inMiniProgram &&
          typeof wx !== 'undefined' &&
          wx.miniProgram &&
          typeof wx.miniProgram.navigateTo === 'function'
        ) {
          try {
            const u = encodeURIComponent(this.qrCodeUrl)
            wx.miniProgram.navigateTo({ url: `/pages/qrAction/index?action=share&url=${u}` })
          } catch (e) {
            console.warn('miniProgram navigateTo share qr failed', e)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.private-doctor-page {
  min-height: 100vh;
  background: #f2f3f5;
}

.pd-body {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;
}

.pd-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #e8faf3 0%, #ffffff 100%);
  box-shadow: 0 4px 14px rgba(0, 194, 117, 0.12);
}

.pd-banner-img {
  width: 72px;
  height: 66px;
  object-fit: contain;
  flex-shrink: 0;
}

.pd-banner-text {
  flex: 1;
  min-width: 0;
}

.pd-banner-title {
  font-size: 17px;
  font-weight: 700;
  color: #333333;
  line-height: 1.35;
}

.pd-banner-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #999999;
}

.pd-section {
  margin-bottom: 12px;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.pd-section-title {
  position: relative;
  padding-left: 10px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  line-height: 1.3;
}

.pd-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #00c275 0%, #4ecdc4 100%);
}

.pd-section-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.75;
  text-align: justify;
}

.pd-service-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pd-service-list li {
  position: relative;
  padding-left: 14px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 1.65;
}

.pd-service-list li:last-child {
  margin-bottom: 0;
}

.pd-service-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00c275;
}

.pd-qr-section {
  margin-top: 4px;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  text-align: center;
}

.pd-qr-title {
  display: inline-block;
  padding-left: 10px;
  margin-bottom: 16px;
}

.pd-qr-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
}

.pd-qr-code {
  width: 200px;
  height: 200px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  object-fit: contain;
  background: #ffffff;
}

.pd-qr-tip {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666666;
  line-height: 1.65;
  text-align: center;
}

.pd-action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.pd-action-btn {
  flex: 1;
  max-width: 150px;
  height: 44px;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  border: none;
}

.pd-save-btn {
  background: linear-gradient(135deg, #00c275 0%, #4ecdc4 100%);
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
}

.pd-share-btn {
  background: linear-gradient(135deg, #4a90e2 0%, #5b9fef 100%);
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.28);
}

.pd-modal {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.45);
}

.pd-modal-content {
  position: relative;
  width: 86%;
  margin: 30vh auto 0;
  padding: 24px 16px 16px;
  border-radius: 16px;
  background: #ffffff;
}

.pd-modal-close {
  position: absolute;
  right: 12px;
  top: 8px;
  font-size: 28px;
  color: #999999;
  line-height: 1;
}

.pd-modal-tip {
  margin: 0 0 20px;
  font-size: 15px;
  color: #333333;
  text-align: center;
}

.pd-modal-card {
  position: relative;
  height: 160px;
  overflow: hidden;
  border-radius: 12px;
}

.pd-modal-card-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pd-modal-card-title {
  position: absolute;
  top: 56px;
  left: 24px;
  margin: 0;
  font-size: 18px;
  color: #333333;
}

.pd-modal-card-desc {
  position: absolute;
  top: 88px;
  left: 24px;
  font-size: 13px;
  color: #666666;
}

.pd-modal-card-btn {
  position: absolute;
  top: 56px;
  right: 16px;
  width: 72px;
  height: 28px;
  border-radius: 16px;
  background: rgb(74, 71, 64);
  color: #f2d57a;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/service/privateDoctor.vue